import { PageId } from 'constants/pages'

export const enum PageIdWoofzNrday80 {
  SUBSCRIPTIONS_NRDAY_80_N = PageId.SUBSCRIPTIONS_NRDAY_80_N,
  CHAT_UPSELL_NRDAY_80 = PageId.CHAT_UPSELL_NRDAY_80,
  UPSELL_NRDAY_80 = PageId.UPSELL_NRDAY_80,
  DOWNLOAD_NRDAY_80 = PageId.DOWNLOAD_NRDAY_80,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
